import { render, staticRenderFns } from "./multimedia-grand-challenge-proposals.vue?vue&type=template&id=70cc0104&scoped=true&"
import script from "./multimedia-grand-challenge-proposals.vue?vue&type=script&lang=js&"
export * from "./multimedia-grand-challenge-proposals.vue?vue&type=script&lang=js&"
import style0 from "./multimedia-grand-challenge-proposals.vue?vue&type=style&index=0&id=70cc0104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc0104",
  null
  
)

export default component.exports